exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.calculable-items-container[data-v-6e709999] {\n    margin-bottom: 20px;\n}\n", ""]);

// exports
